module.exports = __webpack_public_path__ + "img/3.8ca2a4e1.jpg";